import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useJohnDeere from 'hooks/useJohnDeere';

const useData = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState<string | null>(null);
    const hasExchanged = useRef(false);

    const { createConnection } = useJohnDeere();

    useEffect(() => {
        if (hasExchanged.current) {
            return;
        }

        const code = searchParams.get('code');

        if (!code) {
            setError('No authorization code received');

            return;
        }

        hasExchanged.current = true;

        const handleConnection = async () => {
            try {
                await createConnection({ code });

                navigate('/connections');
            } catch (connectionError) {
                const message =
                    connectionError instanceof Error ? connectionError.message : 'Unknown error';

                setError(message);
                hasExchanged.current = false;
            }
        };

        handleConnection();
    }, [createConnection, navigate, searchParams]);

    return {
        error
    };
};

export default useData;
